import { Form, Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import type { UploadChangeParam, UploadFile } from "antd/es/upload";

import "./Filters.css"

const DEFAULT_ACCEPT = ".jpg,.jpeg,.png,.gif,.webp";
const ACCEPT_LABEL   = "JPG, PNG, GIF, WEBP";

export interface FilterImageUploadProps {
    onChange?:           (value: File | null) => void
    className?:          React.HTMLAttributes<HTMLDivElement>['className']
    onDeselect?:         (value: any) => void
    onClear?:            () => void
    required?:           boolean
    customRequiredText?: string
    label?:              string
    /** Used as the button label. Defaults to "Seleziona immagine (JPG, PNG, GIF, WEBP)". */
    placeholder?:        string
    dataKey:             string
    /** Comma-separated list of accepted extensions, e.g. ".jpg,.png" */
    accept?:             string
}

/**
 * A reusable image-upload field that follows the same Form.Item / props
 * pattern as FilterString, FilterBoolean, FilterDate, etc.
 *
 * Usage inside BasicFormModal inputFields (or any <Form>):
 *   <FilterImageUpload dataKey="logo" label="Logo" required={true} />
 *
 * The form field value is the native File object (or null when cleared).
 * The consuming form is responsible for appending it to a FormData before
 * sending a multipart request.
 */
export function FilterImageUpload(props: FilterImageUploadProps) {
    const rules = [{ required: props.required ?? false, message: props.customRequiredText ? props.customRequiredText : 'Il campo è obbligatorio' }]

    function getValueFromEvent(e: UploadChangeParam<UploadFile>) {
        const file = e?.fileList?.[0]?.originFileObj ?? null;
        if (props?.onChange) {
            props?.onChange(file);
        }
        return file;
    }

    const accept      = props.accept ?? DEFAULT_ACCEPT;
    const className   = "filter " + (props?.className ?? "");
    const buttonLabel = props.placeholder ?? `Seleziona immagine (${ACCEPT_LABEL})`;

    return <>
        <Form.Item
            name={props.dataKey}
            label={props.label}
            rules={rules}
            getValueFromEvent={getValueFromEvent}
        >
            <Upload
                accept={accept}
                maxCount={1}
                beforeUpload={() => false}
                listType="picture"
                showUploadList={{ showRemoveIcon: true }}
            >
                <Button icon={<UploadOutlined />} className={className}>
                    {buttonLabel}
                </Button>
            </Upload>
        </Form.Item>
    </>

}
